import Agent from 'agentkeepalive'
import assert from 'shared/utils/assert'
import { createTenantPath } from 'shared/utils/routing'
import APIService from './APIService'
import { ServiceParameters } from './commonTypes/ServiceParameters'

import { API_TIMEOUT_MS } from 'shared/consts'

type AgentType = {
  maxSockets: number
  maxFreeSockets: number
  timeout: number
  freeSocketTimeout: number
}

const agentOptions: AgentType = {
  maxSockets: 100,
  maxFreeSockets: 10,
  timeout: API_TIMEOUT_MS,
  freeSocketTimeout: 15000
}

const keepAliveHttpAgent: Agent = new Agent(agentOptions)
const keepAliveHttpsAgent: Agent.HttpsAgent = new Agent.HttpsAgent(agentOptions)

abstract class BackendAPIService extends APIService {
  protected tenantPath: string
  protected tenant: string
  protected language: string

  constructor(props: ServiceParameters) {
    super(props)

    const { tenant, coreShopEnvironment, language } = props

    assert(tenant, 'APIService: no "tenant" option provided')
    assert(
      coreShopEnvironment,
      'APIService: no "coreShopEnvironment" option provided'
    )
    assert(language, 'APIService: no "language" option provided')

    this.language = language
    this.tenant = tenant
    this.tenantPath = createTenantPath(tenant, coreShopEnvironment)
    this.client.defaults.httpAgent = keepAliveHttpAgent
    this.client.defaults.httpsAgent = keepAliveHttpsAgent
  }
}

export default BackendAPIService
